import { createReducer, Action, on } from '@ngrx/store';

import * as CropAidActions from './crop-aid.actions';
import { CropAidState } from '../crop-aid.model';

const reducer = createReducer<CropAidState>(
  {},
  on(CropAidActions.setGenericCropAids, (state, { cropAids }) => ({
    ...state,
    genericCropAids: cropAids,
  })),
  on(CropAidActions.setProprietaryCropAids, (state, { cropAids }) => ({
    ...state,
    proprietaryCropAids: cropAids,
  })),
);

export const cropAidReducer = (state: CropAidState | undefined, action: Action) =>
  reducer(state, action);
